import React from 'react';
import { Redirect } from 'react-router-dom';

import ExpireSubscriptionButton from 'components/ExpireSubscriptionButton/ExpireSubscriptionButton';
import GenerateMDNChangeFee from 'components/GenerateMDNChangeFee/GenerateMDNChangeFee';
import CheckForOwingLeases from 'components/CheckForOwingLeases/CheckForOwingLeases';
import AttSubNav from 'components/SubNav/att';
import getCarrier from 'helpers/getCarrier';
import ChangeAttMdn from 'components/ChangeAttMdn';

const ChangeMDN = ({
  isAdmin,
  leases,
  sub,
  overduePurchases,
  fetchOwingAction,
  fetchOwing,
  fetchUserOverduePurchases,
  expireSubscription,
  CreateNewSubComponent,
  newSub,
  createSub,
  redirectUrl,
  transferLease,
  updateMdn,
  changeMdnSaveStatus,
}) => {
  const carrier = getCarrier(sub);
  const isAtt = carrier === 'att';

  if (!isAdmin) {
    return <Redirect to={redirectUrl(sub.id)} />;
  }

  if (isAtt && sub && !sub.synced_with_att) {
    return (
      <div>
        <h1>Change MDN</h1>
        <AttSubNav sub={sub} />
        <ChangeAttMdn
          saveStatus={changeMdnSaveStatus}
          onSubmit={(values) => updateMdn(sub.id, values)}
        />
      </div>
    );
  }

  return (
    <div>
      <h1>Change MDN</h1>
      <AttSubNav sub={sub} />
      {sub && (
        <GenerateMDNChangeFee
          sub={sub}
          leases={leases}
          overdue={overduePurchases}
          fetchOverdue={fetchUserOverduePurchases}
          fetchOwingAction={fetchOwingAction}
          fetchOwing={fetchOwing}
        />
      )}
      {sub && (
        <div className="mar-b">
          <CreateNewSubComponent
            sub={sub}
            newSub={newSub}
            createSub={createSub}
          />
        </div>
      )}
      {sub && (
        <CheckForOwingLeases
          sub={sub}
          newSub={newSub}
          fetchOwing={fetchOwing}
          fetchOwingAction={fetchOwingAction}
          transferLease={transferLease}
        />
      )}
      {sub && (
        <ExpireSubscriptionButton
          newSub={newSub}
          expireSubscription={expireSubscription}
          subId={sub.id}
          pin={sub.pin}
          expiry_type={'mdn_change'}
          text="Expire Old Subscription"
        />
      )}
    </div>
  );
};

export default ChangeMDN;
